/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DvdInputs */

const en_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const es_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const fr_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const de_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ja_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const zh_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ar_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قرص (DVD)`)
};

const id_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const it_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ru_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const pt_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ko_val_dvd = /** @type {(inputs: Val_DvdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

/**
* | output |
* | --- |
* | "DVD" |
*
* @param {Val_DvdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_dvd = /** @type {((inputs?: Val_DvdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DvdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_dvd(inputs)
	if (locale === "es") return es_val_dvd(inputs)
	if (locale === "fr") return fr_val_dvd(inputs)
	if (locale === "de") return de_val_dvd(inputs)
	if (locale === "ja") return ja_val_dvd(inputs)
	if (locale === "zh") return zh_val_dvd(inputs)
	if (locale === "ar") return ar_val_dvd(inputs)
	if (locale === "id") return id_val_dvd(inputs)
	if (locale === "it") return it_val_dvd(inputs)
	if (locale === "ru") return ru_val_dvd(inputs)
	if (locale === "pt") return pt_val_dvd(inputs)
	return ko_val_dvd(inputs)
});